<template>
    <div class="thanks-popup">
        <div class="thanks-popup__inner">
            Спасибо за заявку!<br>
            Мы свяжемся с Вами<br>
            в ближайшее время!
            <button
                @click.prevent="$root.$emit('close-thanks-popup')"
                class="thanks-popup__close-btn"></button>
        </div>
        <div
            @click="$root.$emit('close-thanks-popup')"
            class="thanks-popup__overlay"
        ></div>
    </div>
</template>

<script>
export default {
    name: 'thanks-popup',
    mounted() {
        document.body.style = 'overflow: hidden';
    }
}
</script>

<style scoped lang="scss">
.thanks-popup {
    &__inner {
        position: fixed;
        top: calc(50% - 100px);
        left: calc(50% - 125px);
        z-index: 1000;

        width: 250px;
        padding: 20px;

        text-align: center;

        background-color: #fff;
    }

    &__overlay {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 990;
        
        width: 100vw;
        height: 100vh;

        background-color: rgba(0, 0, 0, 0.85);
    }

    &__close-btn {
        position: absolute;
        top: 20px;
        right: 20px;

        display: block;
        padding: 0;
        width: 20px;
        height: 20px;

        background: none;
        background-image: url("../img/icons/icon-close.svg");
        background-repeat: no-repeat;
        background-size: contain;
        border: none;

        cursor: pointer;
    }
}
</style>